import request from '@/utils/request'

export default {
  getOrganizations(qry) {
    return request.post('/reference-data/getOrganizations', qry)
  },
  createOrganization(createOrganizationReq) {
    return request.post(
      '/reference-data/createOrganization',
      createOrganizationReq
    )
  },
  updateOrganization(organization) {
    return request.post('/reference-data/updateOrganization', organization)
  },
  updateOrganizationMapping(organizationMapping) {
    return request.post(
      '/reference-data/updateOrganizationMapping',
      organizationMapping
    )
  },
}
